import React from 'react';
import styled from "styled-components";

const Cylinder = styled.div`
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        width: ${props => props.width + "px"};
        height: ${props => props.height + "px"};
        border-radius: ${props => (props.width/2) + "px/25px"};
        background-color: #000c;

        ::before {
            position: absolute;
            left: 0;
            top: 0;
            width: inherit;
            padding-top: ${props => (50/(props.width/100)) + "%"};
            border-radius: inherit;
            background-color: #222f;
            content: '';
        }

        ::after {
            position: absolute;
            left: 0;
            bottom: 0;
            width: inherit;
            padding-top: ${props => (50 / (props.width / 100)) + "%"};
            border-radius: inherit;
            background-color: #0002;
            content: '';
        }    
    `;

const Indicator = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    width: ${props => props.width + "px"};
    height: 0;
    padding-top: 50px;
    border-radius: inherit;
    background-color: #006f00aa;
    transition: 0.3s linear;

    ::before {
        position: absolute;
        left: 0;
        top: 0;
        width: inherit;
        padding-top:  ${props => (50 / (props.width / 100)) + "%"};
        border-radius: inherit;
        background-color: #006f0055;
        content: '';
    }

    ::after {
        position: absolute;
        left: 0;
        bottom: 0;
        width: inherit;
        padding-top:  ${props => (50 / (props.width / 100)) + "%"};
        border-radius: inherit;
        background-color: #006f00aa;
        content: '';
    }
    `;

export default class TankVolume extends React.Component {
    constructor(props) {
        super(props);
    }
    

    render() {
        const maxLevel = this.props.maxLevel;
        const minLevel = this.props.minLevel;
        const loLevel = this.props.loLevel;
        const highLevel = this.props.highLevel;
        const balance = this.props.level;
        const height = this.props.height;
        const width = this.props.width;
        let balanceHeight = (height - 50) * (balance / maxLevel);

        return (
            <Cylinder height={height} width={width}>
                <Indicator width={width} style={{ height: balanceHeight + "px" }}></Indicator>
            </Cylinder>
        );
    }
}